import React, { Component } from "react";
import { connect } from "react-redux";
import OrderTable from "components/menu/order/OrderTable";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { fetchOrders, emptyOrder } from "../../../actions/orderActions";
import { fetchMerchandisers, emptyMerchandiser } from "../../../actions/employeeActions";
import Spinner from "../../common/Spinner";
import { isEqual } from "lodash";
import sortObject from "../../../functions/sort-object";
import UserTypes from "../../auth/user-types";
import SearchSelect from "../../common/SearchSelect";

class Order extends Component {
    constructor() {
        super();

        this.state = {
            tableState: {},
            page: 0,
            merchandisersOptions: [],
            merchandiser: {},
            requestParams: {}
        };
    }

    componentDidMount() {
        const isNonMerchandiserView = !this.props.userRole.includes(UserTypes.merchandiser);

        if (isNonMerchandiserView) {
            this.props.fetchMerchandisers();
        } else {
            this.handleLoadOrders({
                page: 0,
                pageSize: 20,
                sorted: [
                    // {
                    //     id: "earliestDate",
                    //     desc: false
                    // },
                    // {
                    //     id: "latestDate",
                    //     desc: false
                    // }
                ]
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const newState = {};
        if (!isEqual(nextProps.merchandisers, this.props.merchandisers)) {
            newState.merchandisersOptions = [];
            sortObject(
                nextProps.merchandisers,
                Object.keys(nextProps.merchandisers)
                    .map((value) => parseInt(value, 10)),
                "lastName",
                true
            )
                .forEach(index => {
                    newState.merchandisersOptions.push({
                        value: nextProps.merchandisers[index].id,
                        label: nextProps.merchandisers[index].name
                    });
                });
        }

        if (Object.keys(newState).length) {
            this.setState(newState);
        }
    }

    componentWillUnmount() {
        this.props.emptyOrders();
        this.props.emptyMerchandiser();
    }

    handleSelect = (merchandiser) => {
        if (merchandiser) {
            this.setState({
                merchandiser
            });
        } else {
            this.setState({
                merchandiser: {}
            }, () => {
                this.props.emptyOrders();
            });
        }
    };

    handleLoadOrders = tableState => {
        const {
            merchandiser,
            requestParams
        } = this.state;
        const { value } = merchandiser;

        requestParams.pageNumber = tableState.page;
        requestParams.pageSize = tableState.pageSize;
        requestParams.sortOptions = null;
        requestParams.merchandiserId = value || null;

        // sorts
        if (tableState.sorted && tableState.sorted.length) {
            requestParams.sortOptions = {};
            tableState.sorted.forEach(item => {
                requestParams.sortOptions[item.id] = item.desc;
            });
        }

        this.setState({
            requestParams,
            page: tableState.page,
            tableState: {
                page: tableState.page,
                pageSize: tableState.pageSize,
                sorted: tableState.sorted,
            },
        });

        this.props.fetchOrders(requestParams);
    };

    handlePageChange = (pageIndex) => {
        const requestParams = Object.assign({}, this.state.requestParams);
        const tableState = Object.assign({}, this.state.tableState);
        requestParams.pageNumber = pageIndex + 1;
        tableState.page = pageIndex;
        this.setState({
            requestParams,
            tableState
        }, () => {
            this.handleLoadOrders(tableState);
        });
    };

    handleSortedChange = (sorted) => {
        this.handleLoadOrders({
            page: this.state.tableState.page,
            pageSize: this.state.tableState.pageSize,
            sorted
        });
    };

    handlePageSizeChange = (pageSize) => {
        this.handleLoadOrders({
            page: this.state.tableState.page,
            pageSize,
            sorted: this.state.tableState.sorted
        });
    };

    onViewOrderEntry = (serviceId) => {
        this.props.history.push(`/orderEntry?serviceId=${serviceId}`);
    };

    render() {
        const {
            merchandisersOptions,
            merchandiserId,
            page
        } = this.state;

        const ordersCount = this.props.orders.length || 0;

        const isMerchandiserView = this.props.userRole.includes(UserTypes.merchandiser);

        return (
            <div className="dashboard px-5">
                <h3 className="mb-4">
                    Orders - Select Service
                </h3>

                {
                    !isMerchandiserView ? (
                        <div className="d-flex justify-content-between mb-4">
                            <div className="d-inline-flex">
                                <label className="font-weight-bold mr-2">
                                    Merchandiser
                                </label>
                                <div style={{ width: 250 }}>
                                    <SearchSelect
                                        className="custom-react-select"
                                        isLoading={false}
                                        isClearable={true}
                                        isSearchable={true}
                                        options={merchandisersOptions}
                                        value={merchandiserId}
                                        onChange={(merchandiserId) =>
                                            this.handleSelect(merchandiserId)}
                                    />
                                </div>
                                <button
                                    style={{ width: 45 }}
                                    className="btn btn-sm btn-info ml-2"
                                    onClick={() => this.handleLoadOrders({
                                        page: 0,
                                        pageSize: this.state.tableState.pageSize || 20
                                    })}
                                >
                                    Load
                                </button>
                            </div>
                            <div className="flex-column">
                                <p>{`Total Services ${ordersCount}`}</p>
                            </div>
                        </div>
                    ) : null
                }

                {!this.props.loading || <Spinner/>}

                <OrderTable
                    orders={this.props.orders}
                    orderOptions={this.props.orderOptions}
                    page={page}
                    handleSortedChange={this.handleSortedChange}
                    handlePageChange={this.handlePageChange}
                    handlePageSizeChange={this.handlePageSizeChange}
                    onView={this.onViewOrderEntry}
                />
            </div>
        );
    }
}

Order.propTypes = {
    fetchOrders: PropTypes.func.isRequired,
    orders: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
    userRole: state.auth.user.role,
    orders: state.order.orders,
    orderOptions: state.order.orderOptions,
    loading: state.order.loading,
    merchandisers: state.employee.merchandisers
});

const mapStateToDispatch = dispatch => ({
    fetchOrders: bindActionCreators(fetchOrders, dispatch),
    emptyOrders: bindActionCreators(emptyOrder, dispatch),
    fetchMerchandisers: bindActionCreators(fetchMerchandisers, dispatch),
    emptyMerchandiser: bindActionCreators(emptyMerchandiser, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Order);
